import { defineFetchForNamespace } from '../../redux/fetch';
import { Campaign } from '@pegasus/types/campaign';

import { fetchOpenCampaigns } from '../service';
import { combineReducers } from 'redux';

export const NAME = 'fetch';
export const NAMESPACE = 'opencampaigns';

const { reducer, getIsInitial, getIsLoading, getData, fetchData } = defineFetchForNamespace<
    Campaign[],
    void,
    typeof NAMESPACE,
    typeof NAME
>(NAMESPACE, NAME, () => fetchOpenCampaigns().then(response => response.results));

const getOpenCampaignsReducer = () => ({
    [NAMESPACE]: combineReducers({
        [NAME]: reducer,
    }),
});

export {
    getOpenCampaignsReducer,
    getIsInitial,
    getIsLoading,
    getData as getOpenCampaigns,
    fetchData as fetchOpenCampaigns,
};
